var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "webphone-contact-overlay",
          class: {
            collapsed: _vm.isCollapsed,
            "d-none":
              !_vm.loading && _vm.contacts.length === 0 && _vm.hasSearched,
          },
        },
        [
          _c(
            "div",
            { staticClass: "contact-cards-container" },
            [
              _vm._l(_vm.contacts, function (contact, index) {
                return _c(
                  "div",
                  {
                    key: contact._id,
                    staticClass: "contact-card",
                    on: {
                      click: function ($event) {
                        return _vm.openContactProfile(contact)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "card-content" }, [
                      _c(
                        "div",
                        { staticClass: "profile-avatar" },
                        [
                          _c(
                            "a-avatar",
                            {
                              style: { backgroundColor: "#667eea" },
                              attrs: {
                                size: 28,
                                src: _vm.getContactAvatar(contact),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.getContactInitials(contact)) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "contact-info" }, [
                        _c("div", { staticClass: "contact-name" }, [
                          _vm._v(_vm._s(_vm.getContactName(contact))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "contact-details" }, [
                          _vm.getChannelInfo(contact)
                            ? _c("div", { staticClass: "channel-info" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getPlatformIcon(
                                        _vm.getChannelInfo(contact).type ||
                                          contact.platform
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.getChannelInfo(contact).name)
                                  ),
                                ]),
                              ])
                            : contact.channel
                            ? _c("div", { staticClass: "channel-deleted" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("error_outline"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("Kanal Silinmiş")]),
                              ])
                            : _c("div", { staticClass: "platform-badge" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getPlatformIcon(contact.platform)
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getPlatformName(contact.platform)
                                    )
                                  ),
                                ]),
                              ]),
                          _vm._v(" "),
                          contact.email
                            ? _c("div", { staticClass: "contact-email" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("email"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(contact.email))]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "contact-meta" }, [
                            _vm.getOwnerInfo(contact)
                              ? _c("div", { staticClass: "contact-owner" }, [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("person"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.getOwnerInfo(contact).name)
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "contact-date" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("schedule"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formatDate(contact.createdAt))
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "contact-actions" }, [
                        _c(
                          "div",
                          {
                            staticClass: "action-button",
                            class: { disabled: _vm.isChannelDeleted(contact) },
                            attrs: {
                              title: _vm.isChannelDeleted(contact)
                                ? "Kanal silinmiş - mesaj gönderilemez"
                                : "Mesaj Gönder",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.startChat(contact)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.isChannelDeleted(contact)
                                    ? "block"
                                    : "send"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              !_vm.loading && _vm.contacts.length === 0 && _vm.hasSearched
                ? _c("div", { staticClass: "no-results" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("search_off"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("Bu numara ile eşleşen kişi bulunamadı"),
                    ]),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }